import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultImg from './resortDefaultImages.json';

/* eslint-disable */
var styles = {
    display: 'none'
};
class Offers extends React.Component {
    static propTypes = {};

    static defaultProps = {
        specialOffers: PropTypes.object
    };
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            visible: Object.keys(this.props.specialOffers).map(() => 3),
            specialOffers: {}
        };
        console.log(this.state.visible);
        // this.loadmore = this.loadmore.bind(this);


    }

    loadmore(i) {
        this.setState(pre => {
            return { visible: pre.visible.map((value, index) => ((index === i) ? (value + 3) : value)) };
        });
    }

    render() {
        const specialOffers = this.props.specialOffers;
        const $this = this;
        return (
            <div>
                {Object.keys(specialOffers).map(function (key, index) {
                    const currentData = specialOffers[key];
                    return (
                        <div
                            className="panel"
                            role="tabpanel"
                            aria-expanded="true"
                            key={key}
                        >
                            {key !== "generic" ? 
                                <button className={'panel__label offerTab active'}>
                                    <div className="offerTitle">{key.replace('glass','class')}</div>
                                </button>
                                :''
                            }
                            <div className={'panel__inner'}>
                                <div className="offerItems" key={key}>
                                    {currentData
                                        .slice(0, $this.state.visible[index])
                                        .map((item, index) => {
                                            return (
                                                <div
                                                    className="card"
                                                    key={index}
                                                >
                                                    <div className="card--title">
                                                        {item.island}
                                                    </div>
                                                    {
                                                        Object.entries(defaultImg).map(function ([key, value]) {
                                                            return (
                                                                (item.resortCode === key)
                                                                    ?
                                                                    (<img
                                                                        className="img-responsive use-attributes"
                                                                        src={(item.imagePath === ''
                                                                            ?
                                                                            (value.defaultImgPath)
                                                                            :
                                                                            (`//cdn.sandals.com/uploads/sandals/uk-specials/${item.imagePath}`)
                                                                        )}
                                                                        alt={item.resortShortName}
                                                                        key={key}
                                                                    />)
                                                                    :
                                                                    ''
                                                            );
                                                        })
                                                    }

                                                    {item.roomLevel ===
                                                        'Concierge' ? (
                                                            <div className="red-ribbon-club-level">
                                                                <img
                                                                    src="//cdn.sandals.com/sandals/v12/images/general/specials/uk-specials/beaches_cl_strip.png"
                                                                    alt="club-level"
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    {item.roomLevel ===
                                                        'Butler' ? (
                                                            <div className="red-ribbon-butler">
                                                                <img
                                                                    src="//cdn.sandals.com/sandals/v12/images/general/specials/uk-specials/beaches_butler.png"
                                                                    alt="butler"
                                                                />
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    <div className="card--Content">
                                                        <div className="rShort">
                                                            {item.resortShortName.replace("Sandals", "")}
                                                        </div>
                                                        <div>
                                                            <div className="amount">
                                                                <div className="air_du">

                                                                    {item.duration} inc. {item.airline}
                                                                </div>
                                                                <i>
                                                                    £
                                                                                        {
                                                                        item.price
                                                                    }
                                                                </i>
                                                                <span>
                                                                    PP
                                                                                    </span>
                                                            </div>

                                                        </div>

                                                        <div className="date">
                                                            <p className="txt hContent">
                                                                {
                                                                    item.roomCategory
                                                                }
                                                            </p>
                                                            <div className="textBold">
                                                                Travel
                                                                between
                                                                            </div>
                                                            <p className="dataFormart">
                                                                {

                                                                    moment(item.travelStartDate).format('DD MMM YYYY')
                                                                }{' '}
                                                                                -{' '}
                                                                {

                                                                    moment(item.travelEndDate).format('DD MMM YYYY')
                                                                }
                                                            </p>
                                                            <div className="price">
                                                                <a
                                                                    href="//booking.beaches.co.uk/search"
                                                                    className="bookNow"
                                                                    target="_blank"
                                                                >
                                                                    {' '}
                                                                                    BOOK NOW{' '}
                                                                </a>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                                {$this.state.visible[index] < currentData.length && (
                                    <div className="lm">
                                        <button
                                            onClick={$this.loadmore.bind($this, index)}
                                            className="loadMore"
                                        >Load More</button>
                                    </div>
                                )}
                            </div>
                        </div>

                    );
                })}
            </div>
        );
    }
}

export default Offers;
